/**
 * BrandUnderConstruction Component
 * Displays a friendly message when a brand's products are not yet available
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConstructionIcon from '@mui/icons-material/Construction';
import { BrandsCarousel } from '../../../../shared/components/BrandsCarousel';

// Import styles
import * as styles from './styles';

const BrandUnderConstruction = ({ currentBrandId }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  // Note: useResponsive hook could be integrated here if needed later

  return (
    <Box
      component="main"
      sx={styles.mainContainerStyles}
    >
      {/* Brands Carousel Section */}
      <Box sx={styles.carouselSectionStyles}>
        <Container maxWidth="lg">
          <BrandsCarousel 
            showTitle={false}
            useAlternativeLayout={true}
            isInBrandProductsPage={true}
            currentBrandId={currentBrandId}
          />
        </Container>
      </Box>

      {/* Under Construction Message Section */}
      <Box sx={styles.messageSectionStyles(theme)}>
        <Container 
          maxWidth="lg"
          sx={styles.messageContainerStyles}
        >
          <Box sx={styles.contentWrapperStyles}>
            <ConstructionIcon sx={styles.iconStyles(theme)} />

            <Typography
              variant="h4"
              component="h1"
              gutterBottom
              sx={styles.titleStyles(theme)}
            >
              {t('brands.underConstruction.title')}
            </Typography>

            <Typography
              variant="body1"
              sx={styles.descriptionStyles(theme)}
            >
              {t('brands.underConstruction.description')}
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

BrandUnderConstruction.propTypes = {
  currentBrandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

BrandUnderConstruction.defaultProps = {
  currentBrandId: null
};

export default BrandUnderConstruction; 